import React from 'react';
import styles from './LoadingCircle.module.css';

function LoadingCircle() {
  return (
    <div className={`${styles.loader2} center`}><span></span></div>
  );
}

export default LoadingCircle;
